<template>
    <div class="shopPc">
        <div class="comLibrary">
            <div v-for="(item,index) in items1" class="" :key="index" draggable="true" @dragstart="beforPull" :id="item.id">
                {{item.name}}
            </div>
        </div>
        <div>
            <SlickList  lockAxis="xy" v-model="items2" @sort-start="sortStart" @sort-end="sortEnd"  @input="newList"  class="slickList">
                <SlickItem v-for="(item, index)  in items2" @dragover.native="allowDrop" :id="item.id" :index="index"  :key="index" helper-class="listSelect"  class="slickItem">
                    <div class="itemBox" ref="itemBox" @dragover="allowDrop" @drop="beginPull">
                        <component :id="item.id" :is="item.com" :bor="selectIndex === index"></component>
                    </div>
                </SlickItem>
            </SlickList>
        </div>
    </div>
</template>
<script>
import {SlickList, SlickItem} from 'vue-slicksort'
import ComOne from './ComOne'
import ComTwo from './ComTwo'
import ComThree from './ComThree'
import ComFour from './ComFour'

export default {
    name: 'shopPc',
    data() {
        return {
            items1: [
                {
                    name: '组件1',
                    com: ComOne,
                    id: 'com1'
                },
                {
                    name: '组件2',
                    com: ComTwo,
                    id: 'com2'
                },
                {
                    name: '组件3',
                    com: ComThree,
                    id: 'com3'
                },
                {
                    name: '组件4',
                    com: ComFour,
                    id: 'com4'
                }
            ],
            items2: [
                {
                    name: '组件1',
                    com: ComOne,
                    id: 'com1'
                },
                {
                    name: '组件2',
                    com: ComTwo,
                    id: 'com2'
                },
                {
                    name: '组件3',
                    com: ComThree,
                    id: 'com3'
                },
                {
                    name: '组件4',
                    com: ComFour,
                    id: 'com4'
                }
            ],
            selectIndex: '',
            selectCom: '',
            sort: ''
        }
    },
    mounted() {},
    methods: {
        add() {
            this.colors.push({text: 'wHeader'})
        },
        sortEnd(event) {
            this.selectIndex = event.newIndex
            // console.log(this.items)
        },
        sortStart(event) {
            // console.log(event)
        },
        newList(newList) {
            console.log(newList)
        },
        beforPull(event) {
            console.log(event)
            this.selectCom = event.target.id
        },
        allowDrop(event) {
            event.preventDefault()
            this.sort = event.target.id
            console.log(this.sort)
            console.log(event)
        },
        beginPull(event) {
            event.preventDefault()
            for (let i = 0; i < this.items2.length; i++) {
                if (this.items2[i].id === this.sort) {
                    switch (this.selectCom) {
                    case 'com1': this.items2.splice(i + 1, 0, {name: '组件1', com: ComOne, id: this.getData()})
                        break
                    case 'com2': this.items2.splice(i + 1, 0, {name: '组件2', com: ComTwo, id: this.getData()})
                        break
                    case 'com3': this.items2.splice(i + 1, 0, {name: '组件3', com: ComThree, id: this.getData()})
                        break
                    case 'com4': this.items2.splice(i + 1, 0, {name: '组件4', com: ComFour, id: this.getData()})
                        break
                    }
                    this.sort = ''
                    return
                } else if (this.items2 === false) {}
            }
        },
        getData() {
            return new Date().getTime().toString()
        }
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        SlickList, SlickItem, ComOne, ComTwo, ComThree, ComFour
    }
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss" scoped>
.shopPc {
    display: flex;
    justify-content: flex-start;
    .slickList{
        margin-left: 20px;
        width: 1000px;
        .slickItem{
            padding-top: 10px;
        }
    }
}
</style>
